const openElement = (element) => {
  element.removeAttribute("hidden");
  requestAnimationFrame(() => element.classList.add("is-open"));
};

const closeElement = (element) => {
  element.classList.remove("is-open");
  window.setTimeout(() => {
    if (!element.classList.contains("is-open"))
      element.setAttribute("hidden", "");
  }, 300);
};

export const initHeader = () => {
  const header = document.querySelector(".js-header");
  if (!header) return;

  const serviceButton = header.querySelector(".js-service-menu-button");
  const serviceMenu = header.querySelector(".js-service-menu");
  const spButton = header.querySelector(".js-sp-menu-button");
  const spMenu = header.querySelector(".js-sp-menu");

  const closeServiceMenu = () => {
    if (!serviceButton || !serviceMenu) return;
    serviceButton.setAttribute("aria-expanded", "false");
    closeElement(serviceMenu);
  };

  const closeSpMenu = () => {
    if (!spButton || !spMenu) return;
    spButton.setAttribute("aria-expanded", "false");
    document.body.classList.remove("is-sp-menu-open");
    closeElement(spMenu);
  };

  serviceButton?.addEventListener("click", () => {
    if (!serviceMenu) return;
    const willOpen = serviceButton.getAttribute("aria-expanded") !== "true";
    closeSpMenu();
    serviceButton.setAttribute("aria-expanded", String(willOpen));
    willOpen ? openElement(serviceMenu) : closeElement(serviceMenu);
  });

  spButton?.addEventListener("click", () => {
    if (!spMenu) return;
    const willOpen = spButton.getAttribute("aria-expanded") !== "true";
    closeServiceMenu();
    spButton.setAttribute("aria-expanded", String(willOpen));
    document.body.classList.toggle("is-sp-menu-open", willOpen);
    willOpen ? openElement(spMenu) : closeElement(spMenu);
  });

  spMenu?.addEventListener("click", (event) => {
    if (event.target instanceof Element && event.target.closest("a")) {
      closeSpMenu();
    }
  });

  document.addEventListener("click", (event) => {
    if (
      !(event.target instanceof Element) ||
      event.target.closest(".js-header")
    )
      return;
    closeServiceMenu();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const serviceWasOpen =
      serviceButton?.getAttribute("aria-expanded") === "true";
    const spWasOpen = spButton?.getAttribute("aria-expanded") === "true";
    closeServiceMenu();
    closeSpMenu();
    if (spWasOpen) spButton?.focus();
    else if (serviceWasOpen) serviceButton?.focus();
  });

  window.matchMedia("(width >= 800px)").addEventListener("change", () => {
    closeServiceMenu();
    closeSpMenu();
  });
};
